module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.0.0.box.230.116.1002.159.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.24.0.0.box.230.116.1002.86.q.90"
    }
  }, [_vm._v("TEXAS CANDY CARE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.24.0.1.box.230.225.978.50.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("People ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("like ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fruitcake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cake ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.1.0.box.238.508.1122.262.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0023.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.2.0.box.228.866.1268.580.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.2.0.box.228.866.1262.330.q.50"
    }
  }, [_vm._v("Mix the chopped fruit with the tablespoon of flour. Stir in the chopped pecans, flaked coconut, and the can of condensed milk. Preheat the oven to 250°. Grease and flour a tube pan. Press mixture into pan and bake 11/2 hours. Allow the cake to cool and wrap tightly in cheesecloth. Refrigerate at least 2 weeks. Makes about 24 thin slices.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.1.box.230.1278.1266.168.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("small ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pieces ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("squares ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("angel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("food ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('i', [_vm._v("Seven-")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Minute ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frosting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(see ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.5.0.0"
    }
  }), _vm._v("Old-Fashioned ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Coconut ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe) ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("roll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("coconut ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("party ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.6.0.0"
    }
  }), _vm._v("snowballs. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.3.0.box.562.1548.546.512.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.6.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.6.0.0.2"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ff81eb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0025.vue
// module id = 72
// module chunks = 0